import { COLORS, DEFAULT_DURATIONS, intervalActive, lightState, cycleState } from './trafficLightState.mjs';

export function normalPreset(light) {
    return { id: 'normal', name: 'Normal', mode: 'cycle', duration: 60,
        timings: Object.fromEntries(COLORS.map((color) => [color, light.relays?.find((relay) => relay.action === color)?.timeout ?? light.timings?.[color] ?? DEFAULT_DURATIONS[color]])),
        schedule: light.base_schedule ?? light.schedule?.normal ?? [],
    };
}
export function scheduledPreset(light, date) {
    return (light.presets || []).find((preset) => preset.enabled !== false && preset.schedule?.some((row) => intervalActive(row, date)))
        || (normalPreset(light).schedule.some((row) => intervalActive(row, date)) ? normalPreset(light) : { id: 'night', name: 'Night', mode: 'flash' });
}
export function presetLabel(preset) {
    const behavior = preset.mode === 'hold' ? `Hold ${preset.color}` : 'Cycle';
    return `${preset.name} · ${behavior} · ${preset.schedule?.length ? (preset.enabled === false ? 'Schedule disabled' : 'Scheduled') : 'Temporary'}`;
}
export function startOverride(preset, seconds, current, now) {
    const target = preset.mode === 'hold' ? preset.color : 'red';
    const needsTransition = current.color !== target && current.color !== 'off' && target !== 'amber';
    const transition = needsTransition ? (current.color === 'amber' && current.remaining != null ? current.remaining : Number(preset.timings.amber)) * 1000 : 0;
    return { preset, start: now + transition, end: now + transition + seconds * 1000 };
}
export function runtimeState(light, mode, manual, override, date) {
    const now = date.getTime();
    if (mode === 'manual') return { color: manual === 'flash' ? (date.getMilliseconds() < 500 ? 'amber' : 'off') : manual, remaining: null, label: manual === 'flash' ? 'Flashing amber' : manual };
    if (override && now >= override.end) {
        const automatic = runtimeState(light, 'automatic', manual, null, new Date(override.end));
        const previous = override.preset.mode === 'hold' ? override.preset.color
            : cycleState(Object.entries(override.preset.timings).map(([action, timeout]) => ({ action, timeout })), Math.max(0, (override.end - override.start) / 1000 - 0.001)).color;
        const until = override.end + Number(override.preset.timings.amber) * 1000;
        if (previous !== automatic.color && previous !== 'amber' && automatic.color !== 'amber' && automatic.preset?.mode !== 'flash' && now < until) {
            return { color: 'amber', remaining: Math.ceil((until - now) / 1000), label: 'Amber', preset: override.preset, temporary: true, transitioning: true, returning: true, until };
        }
    }
    const temporary = override && now < override.end;
    const preset = temporary ? override.preset : scheduledPreset(light, date);
    if (temporary && now < override.start) return { color: 'amber', remaining: Math.ceil((override.start - now) / 1000), label: 'Amber', preset, temporary, transitioning: true };
    let state;
    if (preset.mode === 'flash') state = lightState([], 'night', date);
    else if (preset.mode === 'hold') state = { color: preset.color, remaining: temporary ? Math.ceil((override.end - now) / 1000) : null };
    else {
        const relays = Object.entries(preset.timings).map(([action, timeout]) => ({ action, timeout }));
        state = temporary ? cycleState(relays, (now - override.start) / 1000) : lightState(relays, 'normal', date);
    }
    return { ...state, label: preset.mode === 'flash' ? 'Flashing amber' : state.color, preset, temporary };
}
